var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{attrs:{"title":_vm.title,"active":_vm.active,"title-link-class":"paper-tabbed-link","no-body":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }